import { apiFetch } from "./client";

export type SearchHit = {
  kind:
    | "PRODUCT"
    | "NEWS"
    | "MATERIAL"
    | "TM_TASK"
    | "TM_PROJECT"
    | "TM_MEETING"
    | "DELIVERY"
    | "PROCUREMENT_CONTRACT"
    | "RECEIVING_LOT"
    | "DISPATCH_NOTE"
    | "GOODS_LOT";
  id: string;
  title: string;
  snippet: string | null;
  href: string;
};

export type GlobalSearchResults = {
  term: string;
  products: SearchHit[];
  news: SearchHit[];
  materials: SearchHit[];
  tmTasks: SearchHit[];
  tmProjects: SearchHit[];
  tmMeetings: SearchHit[];
  deliveries: SearchHit[];
  procurementContracts: SearchHit[];
  lots: SearchHit[];
  /** Izlazne otpremnice po broju i LOT po oznaci ili barkodu. */
  dispatchNotes: SearchHit[];
  goodsLots: SearchHit[];
};

export const searchApi = {
  search: (q: string, locale = "en") =>
    apiFetch<GlobalSearchResults>(
      `/search?q=${encodeURIComponent(q)}&locale=${encodeURIComponent(locale)}`,
    ),
};

export function totalHits(results: GlobalSearchResults): number {
  return (
    results.products.length +
    results.news.length +
    results.materials.length +
    results.tmTasks.length +
    results.tmProjects.length +
    results.tmMeetings.length +
    results.deliveries.length +
    results.procurementContracts.length +
    results.lots.length +
    results.dispatchNotes.length +
    results.goodsLots.length
  );
}

/** Picks the first hit across all categories in priority order. */
export function firstHit(results: GlobalSearchResults): SearchHit | null {
  return (
    results.tmTasks[0] ??
    results.tmProjects[0] ??
    results.tmMeetings[0] ??
    results.deliveries[0] ??
    results.procurementContracts[0] ??
    results.lots[0] ??
    results.dispatchNotes[0] ??
    results.goodsLots[0] ??
    results.products[0] ??
    results.news[0] ??
    results.materials[0] ??
    null
  );
}
